import React from 'react';
import ContentLoader from 'react-content-loader';
import MediaQuery from 'react-responsive';

const FirmHeaderContentLoader = () => (
  <>
    <MediaQuery query="(min-width: 768px)">
      <div
        className="firm-header"
        style={{ padding: '0', overflow: 'hidden', height: '285px' }}
      >
        <div className="container">
          <div className="firm-header__inner">
            <div
              className="profile-content-loader"
              style={{
                maxHeight: '400px',
                padding: '25px 0',
              }}
            >
              <div className="profile-content-loader--container">
                <ContentLoader
                  height={800}
                  width={1200}
                  speed={2}
                  primaryColor="#f3f3f3"
                  secondaryColor="#ecebeb"
                >
                  <rect x="11" y="15" rx="0" ry="0" width="205" height="205" />
                  <rect x="237" y="16" rx="0" ry="0" width="360" height="27" />
                  <rect x="236" y="70" rx="0" ry="0" width="165" height="71" />
                  <rect x="236" y="166" rx="0" ry="0" width="256" height="19" />
                  <rect x="411" y="68" rx="0" ry="0" width="165" height="71" />
                  <rect x="237" y="196" rx="0" ry="0" width="143" height="19" />
                  <rect x="530" y="166" rx="0" ry="0" width="202" height="43" />
                </ContentLoader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MediaQuery>

    <MediaQuery query="(max-width: 767px)">
      <div
        className="firm-header"
        style={{
          paddingTop: '0',
        }}
      >
        <div className="container">
          <div className="firm-header__inner">
            <div
              className="profile-content-loader"
              style={{
                maxHeight: '400px',
                paddingTop: '15px',
              }}
            >
              <div
                style={{
                  width: '100%',
                  maxWidth: '320px',
                }}
              >
                <ContentLoader
                  height={600}
                  width={320}
                  speed={2}
                  primaryColor="#f3f3f3"
                  secondaryColor="#ecebeb"
                >
                  <rect x="71" y="20" rx="0" ry="0" width="185" height="185" />
                  <rect x="49" y="234" rx="0" ry="0" width="226" height="25" />
                  <rect x="71" y="281" rx="0" ry="0" width="185" height="30" />
                  <rect x="71" y="316" rx="0" ry="0" width="185" height="30" />
                  <rect x="71" y="351" rx="0" ry="0" width="185" height="30" />
                  <rect x="71" y="425" rx="0" ry="0" width="185" height="12" />
                  <rect x="61" y="399" rx="0" ry="0" width="204" height="13" />
                  <rect x="49" y="455" rx="0" ry="0" width="226" height="38" />
                </ContentLoader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MediaQuery>
  </>
);

export default FirmHeaderContentLoader;
